import React from "react";
import styles from "./WizardContent.module.scss";
import {ReactComponent as PreviousArrow} from "../../images/monochrome-icons/ic-arrow-back.svg";
import classNames from "classnames";

const WizardContent = ({children, onPreviousStep, className}) => {
    return <div className={classNames(styles.base, className)}>
        {onPreviousStep && <button type="button" className={styles["previous-step"]} onClick={onPreviousStep}><PreviousArrow/>Previous Step</button>}
        {children}
    </div>
}

export default WizardContent;
